import API from "./api";

const ParametreService = {
  getAll: async (): Promise<Record<string, string>> => {
    const response = await API.get("/parametres");
    return response.data.donnees;
  },

  set: async (cle: string, valeur: string) => {
    const response = await API.put(`/parametres/${encodeURIComponent(cle)}`, { cle, valeur });
    return response.data.donnees;
  },
};

export default ParametreService;
